import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const tradeTl = gsap.timeline({ paused: true });

tradeTl.fromTo(".trade-on-the-go__content h3", { y: 50, opacity: 0 }, { y: 0, opacity: 1 }, 0);

tradeTl.fromTo(".trade-on-the-go__content .title", { y: 50, opacity: 0 }, { y: 0, opacity: 1 }, 0.1);

tradeTl.fromTo(".trade-on-the-go__content .trade-on-the-go__download", { y: 50, opacity: 0 }, { y: 0, opacity: 1 }, 0.2);

ScrollTrigger.create({
  trigger: ".trade-on-the-go__content",
  // start: `top ${window.innerHeight * 0.8}`,
  // start: `top bottom-=6.25rem`,
  // start: `top bottom-=6.25rem`,
  // star
  // start: `top center`,
  start: () => `top 80%`,
  end: "+=300",
  //end: (self) =>  ,
  onUpdate: (self) => {
    tradeTl.progress(self.progress);
  },
});
